// Import React Libraries and Components
import React from "react";
import moment from "moment";
import DatePicker from "../../datePicker/DatePicker";
import DropdownSelect from "../../dropdown/Dropdown";
import TextInput from "../../UIComponent/TextInput";
import { MultiSelectDropdown } from "../../allTypesInputComponents/AllTypeInputComponents";
import ValidationText from "../../../utils/validation/ValidationText";
import ButtonLoader from "../../common/buttonLoader/ButtonLoader";
const CPASAccrediation = (props) => {
    console.log("Membership Typed List:", props)
    return (
        <div>
            <div className="2xl:px-10 2xl:py-10 2xl:pt-7 lg:px-7 lg:py-7 lg:pt-5">
                <div className="grid grid-cols-12 gap-6 w-full ">
                    <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                        <div className="grid grid-cols-12 gap-6">
                            <div className="col-span-12">
                                <h2 className="input-title mb-3">
                                    Subscription Start Date (Issue Date)
                                    {/* <span className="text-[#c00000]">*</span> */}
                                </h2>
                                <div className="disabled-input">
                                    <DatePicker
                                        isDisable={false}
                                        name="subscriptionStartDate"
                                        handleChange={(e) => props.handleChange(e, "CPASAccrediation")}
                                        identity="MembershipSubscription"
                                        value={moment(props.CPASAccrediation.subscriptionStartDate).format("yyyy-MM-DD")}
                                        disabled={true}
                                    // onBlur={(e) => props.validate("subscriptionStartDate", "CPASAccrediation")}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                        <div className="grid grid-cols-12 gap-6">
                            <div className="col-span-12">
                                <h2 className="input-title mb-3">
                                    Subscription End Date
                                    {/* <span className="text-[#c00000]">*</span> */}
                                </h2>
                                <div className="disabled-input">
                                    <DatePicker
                                        isDisable={false}
                                        name="subscriptionEndDate"
                                        handleChange={(e) => props.handleChange(e, "CPASAccrediation")}
                                        identity="MembershipSubscription"
                                        value={moment(props.CPASAccrediation.subscriptionEndDate).format("yyyy-MM-DD")}
                                        onBlur={(e) => props.validate("subscriptionEndDate", "CPASAccrediation")}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                        <div className="grid grid-cols-12 gap-6">
                            <div className="col-span-12">
                                <h2 className="input-title mb-3">
                                    Name to be Printed on Certificate
                                    {/* <span className="text-[#c00000]">*</span> */}
                                </h2>
                                <div className="disabled-input">
                                    <TextInput
                                        name="nameOnCertificate"
                                        className='w-full'
                                        value={props.CPASAccrediation.nameOnCertificate}
                                        identity="nameOnCertificate"
                                        handleChange={(e) => props.handleChange(e, "CPASAccrediation")}
                                        disabled={true}
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                        <div className="grid grid-cols-12 gap-6">
                            <div className="col-span-12">
                                <h2 className="input-title mb-3">
                                    Certificate Membership No
                                    {/* <span className="text-[#c00000]">*</span> */}
                                </h2>
                                <div className="disabled-input">
                                    <TextInput
                                        name="certificateMembershipNo"
                                        className='w-full'
                                        value={props.CPASAccrediation.certificateMembershipNo}
                                        identity="certificateMembershipNo"
                                        handleChange={(e) => props.handleChange(e, "CPASAccrediation")}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                        <div className="grid grid-cols-12 gap-6">
                            <div className="col-span-12">
                                <h2 className="input-title mb-3">
                                    Application For Tier
                                    <span className="text-[#c00000]">*</span>
                                </h2>
                                <MultiSelectDropdown
                                    drpIdentity="Application_Tire"
                                    options={props.applicationTierList}
                                    // isMulti
                                    closeMenuOnSelect={true}
                                    hideSelectedOptions={false}
                                    onChange={props.handleChangeSelectorDropdown}
                                    allowSelectAll={false}
                                    value={props.applicationTierList.find(
                                        (appTier) =>
                                            appTier.value === props.CPASAccrediation?.applicationTierId
                                    )}
                                    disabled={props.CPASAccrediation?.statusId === 4}

                                />
                                {/* <Validation error={props.validState.error.membershipTypeId} /> */}
                            </div>
                        </div>
                    </div>
                    <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                        <div className="grid grid-cols-12 gap-6">
                            <div className="col-span-12">
                                <h2 className="input-title mb-3">
                                    Status
                                    <span className="text-[#c00000]">*</span>
                                </h2>
                                <MultiSelectDropdown
                                    drpIdentity="CpasStatus"
                                    options={props.cpasStatusList}
                                    // isMulti
                                    closeMenuOnSelect={true}
                                    hideSelectedOptions={false}
                                    onChange={props.handleChangeSelectorDropdown}
                                    allowSelectAll={false}
                                    value={props.cpasStatusList.find(
                                        (item) => item.value === props.CPASAccrediation?.statusId
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                    {/* <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                        <div className="grid grid-cols-12 gap-6">
                            <div className="col-span-12">
                                <h2 className="text-xl theme-color font-bold 2xl:mb-1">
                                    Updated By
                                </h2>
                                <div className="disabled-input">
                                    <TextInput
                                        disabled={true}
                                        name="updatedBy"
                                        className='w-full'
                                        value={props.CPASAccrediation.updatedBy}
                                        identity="updatedBy"
                                        handleChange={(e) => props.handleChange(e, "CPASAccrediation")}

                                    />
                                </div>
                            </div>
                        </div>
                    </div> */}
                    {/* <div className="xl:col-span-6 lg:col-span-6 col-span-12 input-sec-texts">
                        <div className="grid grid-cols-12 gap-6">
                            <div className="col-span-12">
                                <h2 className="input-title mb-3">
                                    Last Updated Date
                                    
                                </h2>
                                <div className="disabled-input">
                                    {props.CPASAccrediation.updatedAt === "" || props.CPASAccrediation.updatedAt === null ?
                                        <TextInput
                                            disabled={true}
                                            placeholder=""
                                            type="text"
                                            name="linkedIn"
                                            value="None"
                                            identity="BasicInformation"
                                        />
                                        :
                                        <DatePicker
                                            isDisable={true}
                                            name="updatedAt"
                                            handleChange={props.handleChangeIndividualMember}
                                            identity="updatedAt"
                                            value={moment(props.CPASAccrediation.updatedAt).format("yyyy-MM-DD")}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div> */}


                </div>
            </div>

            {/* Renew Button */}
            <div className="grid grid-cols-12 gap-6 pb-10">
                <div className="xl:col-span-12 lg:col-span-12 col-span-12 px-10 new-btn flex justify-end gap-4">

                    <button
                        className="px-7 py-3 btn-sm btn-blue text-xl text-white font-semibold w-[250px]"
                        onClick={(value) => props.updateCpasStatusManually(value)}
                    >
                        Save
                    </button>

                    <button
                        className="px-7 py-3 btn-sm btn-blue text-xl text-white font-semibold w-[250px]"
                        onClick={() => props.getCPASMemberCertificate()}
                    >
                        Latest Certification
                    </button>

                    <button
                        className="px-7 py-3 btn-sm btn-blue text-xl text-white font-semibold w-[250px]"
                        onClick={(value) => props.viewUpdateCPASMember(value)}
                    >
                        View/Update Details
                    </button>

                </div>
            </div>
        </div>
    );
}
export default CPASAccrediation;